module.exports = __webpack_public_path__ + "static/media/prediction.861bed06.png";